import styled from 'styled-components';
import { COLORS, FONTS } from './../../ui';

export const HeaderWrapper = styled.div`
  width: 100%;
`;
export const HeaderTitle = styled.div`
  display: none;
  align-items: flex-end;
  font-family: ${FONTS.MULI_BOLD};
  font-size: 24px;
  padding-bottom: 7px;
  border-bottom: 1px black dashed;
  color: ${COLORS.TEXT_GRAY};

  ${({ posComponent }) => (posComponent === 'start') && `
    justify-content: space-between;
    flex-direction: row-reverse;

  `}

  ${({ posComponent }) => (posComponent === 'end') && `
    justify-content: space-between;
  `}

  @media(min-width: 480px) {
    display: flex;
  }
`;

export const Title = styled.span``;

export const RenderComponent = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
`;

export const HeaderSubTitle = styled.span`
  display: block;
  font-family: ${FONTS.MULI_REGULAR};
  font-size: 14px;
  font-weight: bold;
  color: ${COLORS.BLACK};

  @media(min-width: 480px) {
    padding-top: 9px;
    font-size: 18px;
    font-weight: normal;
    line-height: 23px;
  }
`;

export const HeaderTitleImage = styled(HeaderTitle)`
  display: flex;
  ${({ pos }) => (pos === 'start') && `
    justify-content: flex-end;
    flex-direction: row-reverse;
    align-items: flex-end;
  `}

  ${({ pos }) => (pos === 'end') && `
    align-items: flex-end;
    justify-content: space-between;
  `}
`;
